module.exports = __webpack_public_path__ + "media/images/client/AssistantChat/avatar-2-b80fd688da28832f743f8fa7b6f73781.png";